'use client';

import Error from 'next/error';
import { useEffect } from 'react';

import { logErrorBoundary } from '@/lib/logger/pino-logger.client';

const GlobalError = ({ error }: { error: globalThis.Error & { digest?: string } }) => {
  useEffect(() => {
    logErrorBoundary(error, { digest: error.digest });
  }, [error]);

  return (
    <html>
      <body>
        <Error statusCode={500} />
      </body>
    </html>
  );
};

export default GlobalError;
